<script>
// Lucide icon (chevron-down) — ISC. Ported as a local SVG: the ERP is Vue 2 and
// cannot take a new dependency (node_modules is a shared symlink).
// Standard: GREENN-ENG-DOC/front-end/design-system/icons.md
export default {
  name: 'ChevronDownIcon',
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    size: {
      type: [Number, String],
      default: 18,
    },
  },
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="m6 9 6 6 6-6" />
  </svg>
</template>
